import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import Colophon from '../common/colophon';
import menuLinks from '../../util/menu_links';
import Sidebar from './sidebar';

const Footer = createReactClass({

  contextTypes: {
    screen: PropTypes.string.isRequired
  },

  renderMenu() {
    let menu;
    if (this.context.screen !== 'mobile') {
      menu = (
        <div>
          <Row className="footer-titles">
            <Col xs={4} md={4} lg={4}>
              About
            </Col>
            <Col xs={4} md={4} lg={4}>
              Researcher
            </Col>
            <Col xs={4} md={4} lg={4}>
              Respondent
            </Col>
          </Row>
          <Row>
            <Col xs={4} md={4} lg={4}>
              <ul>
                <li><a href="/contact">Contact</a></li>
                <li><a href="/team">Company</a></li>
                <li><a href="https://www.pollfish.com/pollfish-and-prodege/" target="_blank">Pollfish & Prodege</a></li>
                <li><a href="https://www.paycomonline.net/v4/ats/web.php/jobs?clientkey=7AD9ACB16C76BC58869E6DD5AC1CEDEE" target="_blank">Careers</a></li>
                <li><a href="http://www.pollfish.com/blog" target="_blank">Blog</a></li>
                <li><Link to="/company/mediakit">Media Kit</Link></li>
              </ul>
            </Col>
            <Col xs={4} md={4} lg={4}>
              <ul>
                <li><a href="https://help.pollfish.com/faq-researchers" target="_blank">FAQ</a></li>
                <li><a href="https://resources.pollfish.com/case-studies/" target="_blank">Case studies</a></li>
              </ul>
            </Col>
            <Col xs={4} md={4} lg={4}>
              <ul>
                <li><Link to="/respondent/opt-out">Opt out</Link></li>
              </ul>
            </Col>
          </Row>
        </div>
      );
    } else {
      menu = (
        <div className="footerMenu sidebar-static">
          <Sidebar items={ menuLinks() } isExpanded full />
        </div>
      );
    }

    return menu;
  },

  render() {
    return (
      <div className="footer">
        { this.renderMenu() }
        <Colophon />
      </div>
    );
  }
});

export default Footer;


